module.exports = __webpack_public_path__ + "static/img/1242x2208-2.dfe89f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/hoopstack/b/1242x2208/1242x2208-2.jpg
// module id = aFiP
// module chunks = 0